"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _utils = require("@superlogica/foundation/utils");

var HelperTextTheme = function HelperTextTheme(themeColors) {
  var neutralColor = themeColors.textDefault;
  return {
    neutral: (0, _utils.parseColor)(neutralColor),
    error: (0, _utils.parseColor)(themeColors.danger),
    danger: (0, _utils.parseColor)(themeColors.danger),
    success: (0, _utils.parseColor)(themeColors.success)
  };
};

var _default = HelperTextTheme;
exports.default = _default;